import { Grid } from '@material-ui/core';
import { useDevice } from 'components/DeviceContext.js';
import React from 'react';
import { Card1, Card2 } from 'components/Card';

const InstrumentosDePlanejamento = () => {
    const { isMobile } = useDevice();
    return (
        <Grid container style={{
            display: 'flex',
            justifyContent: 'space-around',
            padding: isMobile ? '1em' : ' 2em 0 5em',
            fontFamily: 'Open sans',
            fontWeight: 400,
            flexDirection: isMobile ? 'column' : ''
        }}>
            <Grid item md={5} lg={4}>
                <h3 style={{
                    color: 'var(--azul-vivido)',
                    fontWeight: 400,
                    fontSize: '2.5rem'
                }}>FIA Municipal</h3>
                <h3 style={{ color: 'var(--laranja)', fontWeight: 400, fontSize: '1.6rem' }}>Instrumentos de Planejamento do FIA</h3>
                <Grid style={{
                    fontSize: '1em'
                }}>
                    <p>As ações financiadas pelo FIA devem constar basicamente em dois instrumentos: Plano de Ação e Plano de Aplicação de recursos captados.</p>

                    <p><span style={{ fontWeight: 600 }}>Plano de Ação: </span>É o instrumento baseado nos diagnósticos apurados pelos conselheiros.  Ele indica as principais demandas de ações de atendimento.</p>
                    <p style={{ backgroundColor: 'var(--azul-claro)', padding: '0.6em' }}>
                        <span style={{ fontWeight: 600 }}>IMPORTANTE!!!</span><br /> É importante que conste no plano de ação um diagnóstico amplo da realidade em relação as demandas das crianças e dos adolescentes.
                    </p>

                    <p><span style={{ fontWeight: 600 }}>Plano de Aplicação: </span>Plano de aplicação é a programação da distribuição de recursos para áreas avaliadas
                    pelo Conselho dos Direitos da Criança e do Adolescente (CMDCA) como prioritárias, de acordo com as diretrizes fixadas no Plano de Ação, e enviado 
                    ao Poder Executivo antes da aprovação do orçamento do Município, a fim de que seja nele incluído.</p>

                    <p style={{ backgroundColor: 'var(--azul-claro)', padding: '0.6em' }}>
                        <span style={{ fontWeight: 600 }}>IMPORTANTE!!!</span><br /> De posse do Plano de Aplicação do Fundo (a ser conduzido, elaborado e aprovado pelo Conselho de Direitos),
                        o administrador fará o orçamento anual que integrará o Projeto de Lei Orçamentária a ser encaminhado ao Legislativo pelo Executivo.
                    </p>
                </Grid>
            </Grid>
            <Grid item xs={12} md={5} lg={4} style={{
                display: 'flex',
                width: '100%',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <Card1 />
                <Card2 />

            </Grid>
        </Grid>
    );
}

export default InstrumentosDePlanejamento;
